import * as angular from "angular";

import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.shippers')
  .factory('$shippers', ShippersArray);

/* @ngInject */
function ShippersArray($bringozFactory: $bringozFactory,
                       ShippersAPI: BringozApi,
                       Shippers_DS: DataStoreConfig,
                       Shippers_PN: PushNotificationsConfig) {

  function $shippers() {
    return $bringozFactory(null, ShippersAPI, Shippers_DS, Shippers_PN);
  }

  return $shippers;
}
